import React from "react";
// import flexible from '../../utils/flexible';
import "./index.less";

class PrivacyAgreement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        window.location.replace(
            "https://www.hellogil.com/h5Static/PrivacyAgreement.html"
        );
    }

    render() {
        // document.title = '绿色慧联隐私政策';
        return (
            <div className="page_type_h5_select">
                <article id="PrivacyAgreement">
                    <h2 style={{ textAlign: "center" }}>绿色慧联隐私政策</h2>
                    <section className="dataTime">
                        <p>本版本发布日期：2024年08月27日</p>
                        <p>本版本生效日期：2024年08月29日</p>
                    </section>
                    <section>
                        <b>引言</b>
                    </section>
                    <section>
                        浙江绿色慧联有限公司（以下简称“我们”或“绿色慧联”）非常重视用户的隐私和个人信息保护，并根据相关法律法规及国家标准，制定《绿色慧联隐私政策》（以下简称“本政策”），提醒您仔细阅读并了解。本政策阐述了我们如何收集和处理您的个人信息，并为您提供访问和控制您的个人信息的途径。在为您提供优质的产品和服务的同时，我们将根据本政策收集、使用、共享、存储和保护您的个人信息。
                    </section>
                    <section>
                        本政策适用于我们通过远程慧联APP、小程序为您提供的所有服务。但本政策不适用于：
                        <br />
                        <ul>
                            <li>任何第三方向您提供的产品及服务；</li>
                            <li>
                                具有单独的隐私政策并且这些政策并未纳入本政策的特定产品及服务。
                            </li>
                        </ul>
                        我们收集和处理个人信息会因具体产品/服务场景而有所不同，请以您使用产品/服务的具体场景为准。
                    </section>
                    <section>
                        <b>
                            涉及本政策中与您的权益（可能）存在重大关系的政策以及涉及敏感个人信息的处理，我们采取字体加粗提示您重点阅读。
                        </b>
                        <p>
                            我们深知个人信息对您的重要性，秉承您对绿色慧联产品的高度期待值而严谨对待您的个人信息。客户个人信息的保密性和完整性是我们的重点关注领域。我们努力创造和维护与您的互信关系，为保护您的个人信息恪守以下原则：权责一致、目的明确、选择同意、最少必要、确保安全、主体参与、公开透明。同时，我们承诺按业界成熟的安全标准，采取相应的安全保护措施以充分保护您的个人信息。
                            如果您有任何疑问、意见或建议，请通过以下方式与我们联系：400-826-2266
                        </p>
                        <p>
                            本隐私政策将帮助您了解以下内容，您可以根据以下索引阅读相应章节，进一步了解本政策的具体约定：
                        </p>
                        <p>一、我们如何收集和使用您的个人信息</p>
                        <p>二、我们如何使用Cookies及同类技术</p>
                        <p>三、我们如何共享、转让、公开披露您的个人数据</p>
                        <p>四、我们如何保护和保存您的个人信息</p>
                        <p>五、您如何管理您的个人信息</p>
                        <p>六、儿童个人信息的处理</p>
                        <p>七、通知和修订</p>
                        <p>八、如何联系我们</p>
                    </section>
                    <section>
                        <h3>一、我们如何收集和使用您的个人信息</h3>
                        <p>
                            为本政策之目的，“个人信息”，是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
                            <b>
                                “敏感个人信息”是指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹信息以及不满十四周岁未成年人的个人信息。
                            </b>
                            相比其他个人信息，敏感个人信息可能对您的个人权益影响更大。我们在此善意的提醒您需在谨慎考虑后再向我们提供您的敏感个人信息。
                        </p>
                        <p>
                            我们会遵循正当、合法、必要的原则，在下述场景中收集和使用您的个人信息。您可以通过查看
                            <a
                                href="https://www.hellogil.com/payment/#/informationCollectionList"
                                style={{ textDecoration: "none" }}
                            >
                                《个人信息收集清单》
                            </a>
                            快速了解我们如何收集使用您的个人信息。
                        </p>
                        <h4>1.1用户注册、登录</h4>
                        <p>
                            当您注册、登录我们的APP、小程序及使用相关服务时，您需要提供您的
                            <b>手机号码、验证码</b>
                            以完成账号的注册、登录。如果您拒绝提供上述个人信息完成注册、登录，我们可能无法为您提供本APP、小程序提供的相关功能或服务，但您依然可以浏览远程慧联APP、小程序的部分信息。
                        </p>
                        <p>
                            当您注册成功后， 您可在APP客户端
                            “我的-设置-我的信息-登录密码”中设置您的账号密码，后续您可采用
                            <b>手机号码+密码</b>
                            的方式登录，若您选择采用此种登录方式，我们将收集您的
                            <b>手机号码</b>
                            <b>和密码</b>。
                        </p>
                        <p>
                            您可以使用第三方账号(包含：微信)注册、登录我们小程序时，但需要您授权我们获取您在第三方平台的信息，包括您的手机号、OpenID，用于生成与该第三方账号绑定的账号，使您可以直接注册、登录并使用我们的小程序提供的相关功能或服务。部分情况下，我们需要重新验证绑定您的手机号码，以确认该第三方账号的真实性和关联性。
                        </p>
                        <h4>
                            1.2 站点服务（寻找充电站、甲醇站、运营商、服务网点）
                        </h4>
                        <p>
                            当您使用充电站、甲醇站、运营商、服务网点（维保网点、年审网点）查询功能时，基于您的授权，我们需要获取您的
                            <b>地理位置</b>
                            信息，以便为您推荐离最近的充电站、甲醇站、运营商、服务网点相关信息。为了方便您导航，我们接入了第三方地图服务商，您在使用导航服务过程中提供和产生的信息将由地图服务商直接进行处理，且不会向我们共享，相关处理规则请查看他们的个人信息保护政策。若您不同意开启定位权限，我们将无法自动向您展示附近站点，但您仍可以通过页面的搜索功能了解您想要前往的站点位置。
                        </p>
                        <h4>1.3 预约咨询</h4>
                        <p>
                            当您有咨询需求时，可以通过远程慧联APP、小程序预约咨询页面进行预约。当您预约咨询时，我们可能会收集、使用您的所在城市、
                            <b>姓名、手机号码、</b>
                            需求车型。我们将基于您提供的上述信息安排我们或授权服务商的工作人员与您联系，为您提供您需要的服务，帮助您获得更好的预约咨询体验。
                            同时，为确认试乘试驾人员的身份以及机动车驾驶资格，在您试驾前需要提供试驾人的
                            <b>
                                姓名、手机号码、身份证、驾驶证。当您为他人预约咨询和预约试驾时，请确保已取得相关个人信息主体的同意。
                            </b>
                        </p>
                        <h4>1.4 扫码充电 </h4>
                        <p>
                            1）当您使用我们的扫码充电/解地锁功能，经过您的明示同意并授权后，我们会获取您的
                            <b>相机/相册权限</b>
                            ，进行二维码扫描及识别。您可以拒绝
                            <b>相机/相册权限</b>
                            的授权，拒绝后将无法通过进行扫码识别，但不影响您正常使用我们产品与/或服务的其他功能。
                        </p>
                        <p>
                            2）当您成功启动充电后，为便于您了解、查询订单和管理订单，我们将会为您生成充电订单，订单中会包含您的订单编号、下单时间、结算方式、充电信息以及结算信息，并向您展示。您可以通过“我的”-“订单中心”查看和管理您的订单。
                        </p>
                        <p>
                            3）如果您使用了第三方充电桩充电，我们需要将您的充电订单号提供给为您提供服务的充电桩运营方，以便完成充电及费用结算。
                        </p>
                        <p>
                            4）部分充电场站所在的停车位运营方可以为使用我们充电服务的用户提供限时免费停车，若您希望享受此项服务，您需要向我们提供您的车牌号，并同意我们将车牌号共享给充电桩运营方。若您不提供车牌号，将无法享受限时免费停车优惠，但不影响您正常使用我们产品与/或服务的其他功能。
                        </p>
                        <p>
                            5）若您需要开具发票，根据相关法律法规规定，需要您向我们提供信息包括：发票抬头（姓名）、税号、发票金额、接收电子发票的邮箱，用于为您开具相应的发票，如您不提供这些信息，我们可能无法为您提供电子发票开票服务，但不影响您正常使用我们提供的其他功能和/或服务。
                        </p>
                        <h4>1.5 实名认证</h4>
                        <p>
                            1）当您使用租车服务并选择电子合同签署形式时，为满足法律法规及监管要求、保护您的人身财产安全以及满足我们的风控管理要求，您需要通过远程慧联APP“我的”-“我的信息”-“会员认证”页面按照认证指引完成认证。为了完成实名认证服务，我们将依据相关法律法规收集您的
                            <b>
                                姓名、身份证件号码、身份证正反面照片、手机号码
                            </b>
                            。同时，请您理解，
                            <b>身份证件号码、身份证正反面照片</b>
                            属于您的敏感个人信息，我们收集该类信息是基于实名认证程序要求，如您拒绝提供可能导致您无法使用我们的租车服务，请您谨慎考虑后再选择是否提供。
                        </p>
                        <p>
                            2）为便于快速识别图像信息，我们将使用OCR识别功能，但该功能需要向您申请
                            <b>相机/相册权限</b>
                            ，用于准确识别出您的身份证信息，该服务由杭州尚尚签网络科技有限公司处理您的证照图像识别。
                        </p>
                        <p>
                            3）当您使用手机号码进行实名认证时，为了准确验证您的身份，我们需要将您的
                            <b>姓名、手机号码、身份证号码</b>
                            传输至杭州尚尚签网络科技有限公司，由其提供给合法存有您个人信息的第三方机构进行比对核验。也请您放心，我们会要求其仅用于实名认证的目的，处理目的完毕后即进行删除或匿名化处理，并采取相应的管理和安全技术措施来保护您的个人信息。
                        </p>
                        <p>
                            4）当您使用刷脸认证时，为了准确验证您的身份，我们需要将您的
                            <b>姓名、身份证号码</b>
                            传输至杭州尚尚签网络科技有限公司，并由其完成刷脸认证服务，并反馈给我们认证结果。
                        </p>
                        <p>
                            5）
                            请您理解，我们会尽最大努力保障您的个人信息安全，并严格要求杭州尚尚签网络科技有限公司对您的个人信息保密，只以实名认证之目的获悉和使用，不得对无关方泄露或做其他任何用途。
                        </p>
                        <h4>1.6 合同签署</h4>
                        <p>
                            当您选择使用租车服务，并完成实名认证后，您可以在远程慧联APP”首页”-“签署管理”页面以电子方式签署合同，电子签署服务由第三方服务商杭州尚尚签网络科技有限公司提供。基于该功能，我们会使用并向第三方服务商共享您的
                            <b>姓名、手机号码</b>
                            ，我们也会收集并留存您的电子合同相关文件。同时，第三方服务商可能会收集您的个人信息以核验您的身份，具体详见第三方服务商的隐私政策。如果您与我们发生合同纠纷，我们会向第三方服务商申请调取您签约过程的相关数据。
                        </p>
                        <h4>1.7 支付功能</h4>
                        <p>
                            当您购买充电卡、租车账单还款等其他场景需要支付订单时，您可以选择第三方支付机构（如微信支付、支付宝支付）所提供的支付服务。在您选择支付方式后，您将直接跳到相关支付页面支付。为留存您的支付凭证，我们将从第三方支付平台收集您的该笔订单的
                            <b>支付记录、支付方式、支付金额信息</b>
                            。我们会将您的
                            <b>订单号、订单状态及交易金额信息</b>
                            与第三方支付机构共享，以确认您的支付指令并帮助您完成支付。
                        </p>
                        <h4>1.8 租车订单</h4>
                        <p>
                            当您在绿色慧联线下网点完成车辆租赁后，对应的租赁订单信息会同步至远程慧联APP“我的”-“订单中心”-“租车订单”中进行展示以方便您查看，订单中会包含您租赁车辆的车牌号、车型、租赁信息、还款明细以及租车记录。
                        </p>
                        <h4>1.9 车载驾驶员疲劳监测系统（DMS）</h4>
                        <p>
                            若您作为租赁绿色慧联车辆的用车司机，为加强您的行车安全、同时便于管理车辆及保护我们的资产安全等风险管控目的，我们在交付给您使用的部分车辆配备DMS设备，在您使用这些车辆并当达到一定车速时，我们会通过DMS设备收集
                            <b>车内录像信息</b>
                            ，一般情况下，这些数据将在本地处理，但是在识别并分析到您有危险驾驶行为时，我们需要将危险事件发生前后各5秒的
                            <b>车内录像</b>、危险驾驶行为发生时抓拍的
                            <b>车内图片</b>
                            上传云端，以便进行风险分析与干预，在有可能发生危险时，及时通知司机避免或减轻事故发生，相关驾驶信息更有利于帮助责任判定。
                        </p>
                        <p>
                            车内录像在车载设备内的保存期限受车载设备内存限制，当存储空间已满时会自动删除最早的录像，车内录像将加密保存。因使用场景不同，录像和图片上传云端后的保存期限为15日至6个自然月不等（在满足特定使用场景后立即删除或者匿名化）。如遇投诉、尚未处理完毕的纠纷等，我们将适当延长录像和图片的保存期限。
                        </p>
                        <h4>1.10 用车管理</h4>
                        <p>1）绑定车辆</p>
                        <p>
                            当您使用在绿色慧联租赁的车辆时，为便于您管理您使用的车辆及进行车辆信息查询，您可以通过上传您的
                            <b>车辆行驶证照片</b>
                            进行车辆绑定。为便于快速识别图像信息，我们为您提供了OCR识别功能，但该功能需要向您申请
                            <b>相机/相册权限</b>
                            ，如果您不授权，可能会导致我们无法为您提供该业务功能，但不影响隐私政策下其他功能与服务的正常使用。请您注意，为准确识别出您的行驶证信息，由第三方公司阿里云计算有限公司处理您的行驶证照片图像识别。也请您放心，我们会要求其处理您上传的图像仅限于图像识别的目的，处理目的完毕后即进行删除或匿名化处理，并采取相应的管理和安全技术措施来保护您的个人信息。
                        </p>
                        <p>
                            当您使用非绿色慧联租赁的车辆时，并期望使用我们为您提供的维保、年审服务时，为向您提供便捷的预约服务，您也可以选择按照上述方式绑定车辆，但此信息为选填，您不绑定车辆也不会影响我们为您提供的其他功能/服务。
                        </p>
                        <p>2）车辆授权</p>
                        <p>
                            当您作为租赁绿色慧联车辆客户指定的车辆管理员时，为便于您对车辆进行管理和分配，您可通过远程慧联APP”首页”-“车辆授权”功能向您的用车司机进行授权，授权的司机将可以通过本APP查看授权车辆的实时位置、违章、年审、维保和保险信息以及车辆状态信息（包括车辆型号、里程、电量），为提供车辆授权服务，我们会收集您提供的司机
                            <b>手机号码、姓名</b>
                            ，另外，您也可以随时解除对司机的授权。
                        </p>
                        <p>
                            <b>
                                提请您特别注意的是，在您向我们提供司机个人信息前，请确保您已获得相关个人信息主体的同意。
                            </b>
                        </p>
                        <p>3）车辆监控</p>
                        <p>
                            当您作为租赁绿色慧联车辆客户或其指定的车辆管理员、或者被授权的用车司机时，为便于您因业务需要查看车辆位置和状态、确保用车安全等风险管控目的，您可通过“车辆监控”查看您有权管理的或者租用的车辆的实时位置。
                            <b>
                                请注意，根据适用法律法规要求，车辆位置信息若与驾驶司机建立关联，可能构成敏感个人信息，因此在您查看车辆位置信息时，请遵守适用法律法规要求，避免侵犯他人的个人信息权益或违反相关法律法规规定。
                            </b>
                        </p>
                        <p>4）维保预约/年审预约</p>
                        <p>
                            您可通过远程慧联APP“首页”-“维保预约/年审预约”模块使用车辆维保预约/年审预约服务。为向您提供相关服务，我们会收集您的意向车牌号、预约服务网点、服务类型（保养、维修）、维修类型（日常维修、年审维修）、预约时间、备注或者故障描述、故障照片（可选）、联系人
                            <b>姓名、手机号码</b>
                            ，如您不提供相关个人信息，可能无法通过远程慧联APP进行维保预约/年审预约，但不影响隐私政策下其他功能与服务的正常使用。经过您的明示同意并授权后，我们会获取您的
                            <b>相机/相册权限</b>，进行故障照片的上传。您可以拒绝
                            <b>相机/相册权限</b>
                            的授权，拒绝后将无法上传故障照片，但不影响您正常使用我们产品与/或服务的其他功能。基于您的同意，我们会向您申请使用
                            <b>位置权限</b>，以获取您的<b>地理位置信息</b>
                            来为您推荐最近服务网点，若您不同意提供位置权限，您仍可通过手动搜索选择服务网点进行预约。我们将基于您提供的上述信息安排我们或授权服务商的工作人员与您联系，为您提供您需要的服务。
                        </p>
                        <p>5）安全培训</p>
                        <p>
                            为提升安全驾驶意识，保障安全驾驶，您可通过远程慧联APP“首页-安全培训”页面参加我们为您提供的安全培训课程。为提供该功能/服务，我们将记录您的课程名称、学习时长、学习课时数、完成状态、学习历史、培训记录、本月排名、我的证书以及课程浏览记录(本功能不涉及定向推送)。
                        </p>
                        <h4>1.11 收藏功能</h4>
                        <p>
                            在您使用我们产品/服务的过程中，您可以收藏感兴趣的充电站、线路、和服务网点（维保网点、年审网点），我们会记录您收藏的信息，便于您查看收藏的充电站、线路、和服务网点。
                        </p>
                        <h4>1.12 客服、其他用户响应功能</h4>
                        <p>
                            当您与我们的客服（在线客服、客服热线等）互动时或使用其他用户响应功能时（包括：服务咨询、提出我们的产品与服务的售后申请、行使您的相关个人信息控制权、其他客户投诉和需求），为了您的账号与系统安全，我们可能需要您先行提供账号信息，并与您之前的个人信息相匹配以验证您的用户身份。在您使用客服或其他用户响应功能时，我们可能还会需要收集您的如下个人信息：
                            <b>
                                联系方式（您与我们联系时使用的电话号码/电子邮箱或您向我们主动提供的其他联系方式）、您与我们的沟通信息（包括文件/文字/图片/音视频/通话记录形式）
                            </b>
                            。当您需要我们提供与您订单相关的客服服务时，我们可能会查询您此账号下的订单信息，并同步给相关服务提供方，以便给予您适当的帮助和处理，当您在与我们的客服人员沟通时，基于您的不同客服需求，可能需您提供上述信息以外的其他信息，以便我们为您解决问题，具体以实际场景为准。我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供可能导致您无法使用我们的客服响应机制。
                        </p>
                        <h4>1.13 活动参与/活动分享</h4>
                        <p>
                            我们可能会开展各种各样的活动，并可能会在活动中收集您的个人信息。当您参与我们提供的抽奖活动、推广活动及营销活动时，可能需要您向我们提供或允许我们收集的必要信息包括：姓名、
                            <b>手机号码</b>
                            、及微信OpenID，以向您提供相关产品与/或服务。根据不同的活动性质，可能需要您提供不同的个人信息。如您获得的奖品为实物，我们可能与您联系，并且需要您向我们提供您的
                            <b>收货地址信息</b>
                            ，我们将通过快递的方式，将奖品寄送给您。如您不提供以上这些信息，将无法参与我们的活动或获取奖品，但不影响您正常使用我们提供的其他服务/功能。
                        </p>
                        <h4>1.14 活动通知/信息推送</h4>
                        <p>
                            为了让您更好地了解和使用我们的产品和服务，我们可能会通过APP站内信、弹窗、轮播图、短信、电话、邮件等方式向您发送您可能感兴趣或需要知晓的信息，包括我们的产品及/或服务、消息及广告、调研、活动、促销、推广以及其他提醒信息。
                            <b>
                                如您拒绝接收我们发送的信息或电话回访，您可按照短信内容的提示或语音提示退订本功能，或根据通过下述“联系我们“所载明的联系方式与我们取得联系，我们将立即停止向您发送上述消息或进行电话回访。您可以在您设备的“设置-应用-通知”或远程慧联APP“首页”-“设置”-“消息通知”中关闭APP通知功能。
                            </b>
                            同时提示您，您关闭或退订上述功能后将无法及时获知我们的最新活动信息及相关资讯。
                        </p>
                        <h4>1.15 数据统计分析</h4>
                        <p>
                            请您知晓，我们可能会对您提供的上述信息采取匿名化或去标识化，形成不包含您个人身份识别信息的统计型信息和报告，为研究开发、用户群体分析、产品/服务改良目的进行妥善处理，可能会包括对外提供或公开。
                        </p>
                        <h4>1.16 保障运营与安全运行</h4>
                        <p>
                            为维护服务正常运行，保障账户和交易安全，在您访问及使用我们的产品/服务过程中，我们需要收集您的日志信息、设备信息，包括您的硬件设备型号、屏幕宽度和高度、您所使用的软件版本信息、您的操作系统及版本、您的IP地址、移动网络信息、您的设备ID、设备制造商、设备型号、运营商、运行中进程、Android
                            ID、IDFA、IDFV、OAID、UUID，用于判断账户安全、检测及防范安全事件，以便为您提供安全、可信的产品与使用环境。
                        </p>
                        <h4>1.17 绿色慧联权限获取说明 </h4>
                        <p>
                            为向您提供便捷、优质的服务，我们的产品和/或服务中可能需要使用系统权限，这些权限只有经过您的明示授权才会开启，并且仅在相关功能或服务需要时才会收集您的个人信息。我们对远程慧联APP、小程序所调用的系统权限进行归纳整理，您可以根据实际需要对相关权限进行管理，具体权限调用内容详见
                            <a
                                href="https://www.hellogil.com/h5Static/#/PermissionDescribe"
                                style={{ textDecoration: "none" }}
                            >
                                《应用权限说明》
                            </a>
                            。
                        </p>
                        <p>
                            您可以在您的移动终端中逐项查看您上述权限的开启状态，并可以决定将这些权限随时开启或关闭。
                            <b>
                                请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。
                            </b>
                        </p>
                        <h4>
                            <b>
                                2. 根据相关法律法规及国家标准，在以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的同意：
                            </b>
                        </h4>
                        <p>
                            <b>（1）与国家安全、国防安全有关的；</b>
                        </p>
                        <p>
                            <b>
                                （2）与公共安全、公共卫生、重大公共利益有关的；
                            </b>
                        </p>
                        <p>
                            <b>
                                （3）与犯罪侦查、起诉、审判和判决执行等有关的；
                            </b>
                        </p>
                        <p>
                            <b>
                                （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
                            </b>
                        </p>
                        <p>
                            <b>
                                （5）
                                所收集的个人信息是个人信息主体自行向社会公众公开的；
                            </b>
                        </p>
                        <p>
                            <b>
                                （6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
                            </b>
                        </p>
                        <p>
                            <b>（7）根据您的要求签订合同所必需的；</b>
                        </p>
                        <p>
                            <b>
                                （8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；
                            </b>
                        </p>
                        <p>
                            <b>（9）为合法的新闻报道所必需的；</b>
                        </p>
                        <p>
                            <b>
                                （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
                            </b>
                        </p>
                        <p>
                            <b>（11）法律法规规定的其他情形。</b>
                        </p>
                        <h4>3. 其他</h4>
                        <p>
                            请您理解，我们向您提供的服务是不断更新和发展的，
                            <b>
                                如您选择使用了前述说明中尚未涵盖的其他服务，基于该服务我们需要收集您的信息的，我们会通过页面提示、交互流程、协议约定的方式另行向您说明信息收集的范围、方式与目的，并征得您的同意
                            </b>
                            ，我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；如您选择不提供前述信息，您可能无法使用某项或某部分服务，但不影响您使用我们提供的其他服务。
                        </p>
                        <p>
                            在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。
                            <b>
                                请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并用于产品/服务的改善优化，新产品开发的利用。
                            </b>
                        </p>
                    </section>
                    <section>
                        <h3>二、我们如何使用Cookies及同类技术</h3>
                        <h4>2.1 Cookies的使用</h4>
                        <p>
                            我们将在您访问远程慧联APP、小程序时使用“Cookie”。Cookie是由网络服务器存储在设备硬盘的小文本文件。我们可能使用
                            Cookie
                            和类似的技术，包括您访问APP、小程序的习惯、您的浏览信息、您的登录信息，存储用户偏好和设置的网络信标，以防止欺诈、认证用户、并收集有关服务的操作信息。您可以通过改变浏览器附加程序的设置拒绝或管理
                            Cookie。但请注意，如果停用Cookie，您有可能无法享受最佳的服务体验，也可能无法正常使用远程慧联APP、小程序的服务。
                        </p>
                    </section>
                    <section>
                        <h3>三、我们如何共享、转让、公开披露您的个人数据</h3>
                        <h4>3.1共享</h4>
                        <p>
                            原则上我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，但以下情形除外：
                        </p>
                        <p>（1）获得您的明确授权或同意；</p>
                        <p>
                            （2）根据适用的法律法规、法律程序要求或强制性的政府要求或司法裁定必须提供；
                        </p>
                        <p>
                            （3）在采取有效的保护您的个人信息安全措施（包括但不限于签订相关保密协议等）的前提下，向以下主体进行共享，并在此征得您的授权同意：
                        </p>
                        <h5>3.1.1关联公司/运营商</h5>
                        <p>
                            我们可能会将您的个人信息与我们的关联公司/运营商共享，并保证其将按照本政策所示目的和要求对您的个人信息进行相应的处理，例如当您使用预约咨询服务时，我们会根据您的选择安排我们授权运营商的工作人员与您联系，为您提供您需要的服务。如关联公司/运营商希望将您的个人信息用于本政策所载目的以外的其他目的，我们将再次征得您的同意。
                        </p>
                        <h5>3.1.2第三方服务提供商</h5>
                        <p>
                            我们可能会在特定领域与第三方服务提供商合作，为您提供服务。我们可能会将您的个人信息与这些第三方服务提供商共享，并保证其按照我们的指示，遵循本政策所载目的和要求处理您的个人信息，并采取适当的保密和安全措施保障信息安全。
                        </p>
                        <p>
                            对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协议或数据处理协议，要求其根据我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。我们共享个人信息的具体情况详见
                            <a
                                href="https://www.hellogil.com/h5Static/#/threeShareList"
                                style={{ textDecoration: "none" }}
                            >
                                《第三方信息共享清单》
                            </a>
                            。
                        </p>
                        <p>
                            同时，为了使您能够接受信息推送、使用支付功能等必要的功能用途，我们的APP、小程序或在为您提供服务的过程中会嵌入授权合作伙伴的SDK或其他类似的应用程序。对我们与之共享个人信息的公司、组织和个人，我们将审慎评估合作方使用信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵守合作协议。我们对合作方获取信息的SDK或其他类似的应用程序进行严格的安全监测，以保护您的信息安全。详见
                            <a
                                href="https://www.hellogil.com/h5Static/#/listOfThirdSDK"
                                style={{ textDecoration: "none" }}
                            >
                                《第三方SDK清单》{" "}
                            </a>
                            。
                        </p>
                        <h4>3.2转让</h4>
                        <p>
                            我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：
                        </p>
                        <p>
                            （1）获得您的明确同意后，我们会向其他方转让您的个人信息；
                        </p>
                        <p>
                            （2）在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
                        </p>
                        <h4>3.3 公开披露</h4>
                        <p>我们仅会在以下情形下，公开披露您的个人信息：</p>
                        <p>（1）获得您明确同意后；</p>
                        <p>
                            （2）在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
                        </p>
                        <h4>3.4 征得您授权同意的例外</h4>
                        <p>
                            以下情形中，共享、转让、公开披露个人信息无需征得您的授权和同意：
                        </p>
                        <p>（1）与您履行法律法规规定的义务相关的；</p>
                        <p>（2）与国家安全、国防安全直接相关的；</p>
                        <p>
                            （3）与公共安全、公共卫生、重大公共利益直接相关的；
                        </p>
                        <p>
                            （4）与刑事侦查、起诉、审判和判决执行等直接相关的；
                        </p>
                        <p>
                            （5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；
                        </p>
                        <p>（6）个人信息主体自行向社会公众公开的个人信息；</p>
                        <p>
                            （7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
                        </p>
                        <p>
                            请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得信息接收方无法重新识别特定个人且不能复原，则此类处理后信息的共享、转让、公开披露无需另行向您通知并征得您的同意。
                        </p>
                    </section>
                    <section>
                        <h3>四、我们如何保护和保存您的个人信息</h3>
                        <h4>
                            <b>
                                1. 我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：
                            </b>
                        </h4>
                        <p>(1)数据安全技术措施</p>
                        <p>
                            我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。绿色慧联的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全。
                        </p>
                        <p>
                            绿色慧联采取加密技术对用户个人信息进行加密保存。在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用内容替换等数据脱敏技术增强个人信息在使用中安全性。绿色慧联采用严格的数据访问权限控制保护个人信息，避免数据被违规使用。
                        </p>
                        <p>(2)绿色慧联为保护个人信息采取的其他安全措施</p>
                        <p>
                            绿色慧联通过数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。绿色慧联通过信息保密协议、监控和审计机制来对数据进行全面安全控制。加强安全意识。我们还会举办信息安全培训课程，加强员工对于保护个人信息重要性的认识。
                        </p>
                        <p>
                            (3)我们仅允许有必要知晓这些信息的绿色慧联及绿色慧联关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们的合作关系。
                        </p>
                        <p>
                            (4)我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
                        </p>
                        <p>
                            (5)互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。
                        </p>
                        <p>(6)安全事件处置</p>
                        <p>
                            为应对个人信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们会按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。
                        </p>
                        <p>
                            在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、电话或推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
                        </p>
                        <h4>2. 您个人信息的保存</h4>
                        <p>(1)信息存储的地点</p>
                        <p>
                            我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循法律法规的规定，征求您的自主选择同意。
                        </p>
                        <p>(2)存储期限</p>
                        <p>
                            我们将在实现信息收集和处理目的的必要期限内存储您的个人信息。超出上述期限，我们将对个人信息进行删除或匿名化处理，除非法律法规有强制的留存要求。
                        </p>
                    </section>
                    <section>
                        <h3>五、您如何管理您的个人信息</h3>
                        <p>
                            绿色慧联非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：
                        </p>
                        <h4>1、访问您的个人信息</h4>
                        <p>
                            除法律法规规定的例外情形外，您有权随时访问您的个人信息，可以通过以下方式自行查询：
                        </p>
                        <p>
                            1）通过“我的”-“设置”-“头像”或者“我的”-“设置”-“我的信息”，您可以访问您的昵称、手机号码、认证名称；
                        </p>
                        <p>
                            2）
                            通过“我的”-“订单中心”，您可以查阅您的租车订单、充电订单信息；
                        </p>
                        <p>
                            3）通过“我的”，您可以查阅您的充电卡余额、优惠券信息、我的积分；
                        </p>
                        <p>
                            4）通过“我的”-“车辆管理”，您可以查阅您绑定车辆或在租车辆的信息；
                        </p>
                        <p>
                            5）通过“我的”-“我的收藏”，您可以查阅您收藏的信息；
                        </p>
                        <h4>2、更正/补充您的个人信息</h4>
                        <p>
                            除法律法规规定的例外情形外，您有权随时更正或补充您的个人信息，可以通过以下方式进行更正/补充：
                        </p>
                        <p>
                            1）通过“我的”-“设置”-“头像”或者“我的”-“设置”-“我的信息”，您可以补充您的头像、修改您的昵称、修改您绑定的手机号码、修改您登录密码。
                        </p>
                        <h4>3、获取您的个人信息副本</h4>
                        <p>
                            如您需要获取我们收集的您的个人信息副本，可以通过以下方式获取：
                        </p>
                        <p>
                            1）通过“我的”-“设置”-“隐私管理”-“个人信息下载”，以复制您的个人信息并发送至您指定的邮箱；
                        </p>
                        <p>
                            2）您还可通过本政策载明的联系方式与我们联络，相关人员会对您进行必要的身份验证后，在符合相关法律规定且技术可行的前提下，将个人信息副本提交给您。如您请求将您的个人信息转移至您指定的个人信息处理者，符合国家网信部门规定条件的，我们将提供转移的途径。
                        </p>
                        <h4>4、改变您授权同意的范围或撤回您的授权</h4>
                        <p>
                            您可以通过删除信息、关闭设备功能/权限等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。
                        </p>
                        <p>
                            请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
                        </p>
                        <h4>5、拒绝接收广告</h4>
                        <p>
                            您始终可以选择是否接收来自我们或第三方的促销电子邮件、短信、电话和信件。您还可以通过取消订阅的方式选择不再接收基于兴趣的广告。当收到您拒绝接收广告的要求后，我们将不再使用您的个人信息做上述商业推广用途。
                        </p>
                        <h4>6、删除您的个人信息</h4>
                        <p>
                            在以下情形中，您可以向我们提出删除个人信息的请求：
                        </p>
                        <p>
                            （1）您的个人信息对于实现收集或处理的目的已不再必要；
                        </p>
                        <p>（2）您已经撤回我们对您个人信息处理的同意；</p>
                        <p>（3）个人信息被非法处理；</p>
                        <p>
                            （4）根据适用法律要求，我们有义务对您的个人信息进行删除。
                        </p>
                        <p>
                            您可以通过“我的”-“帮助与反馈”、在线客服或本政策载明的联系方式提出您的删除请求。请您知悉，对于您提出的敏感个人信息删除请求，我们将在10个工作日内进行删除，一般个人信息将在15个工作日内进行删除。当您从我们的服务中删除或请求删除个人信息后，因法律法规要求的最低存储期限以及安全技术限制，我们可能不会立即在备份系统中删除相应的信息，我们只会做存储不会进行其他用途直至达到法定保存期限时删除，同时，我们不会开展除存储和采取必要的安全保护措施之外的处理。
                        </p>

                        <h4>7、注销账户</h4>
                        <p>
                            您有权注销您的账号。您可以通过访问远程慧联APP、小程序页面上的“我的”-“设置”-“账户与安全”-“账号注销”申请注销账号，或本政策载明的联系方式联系我们协助您注销，提交申请后，我们将在15个工作日内审核，确认您的账户处于安全状态、账号下无任何关联车辆、账号财产结清、无进行中的订单等问题后，我们将为您注销账户。
                            您注销账户后，我们将停止为您提供产品/服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息或做匿名化处理。
                        </p>
                        <p>
                            <b>
                                出于技术原因，我们可能无法立即删除您的个人信息或做匿名化处理。我们将在系统更新时（收到您请求后的15个工作日内）删除这些个人信息或做匿名化处理。在收到您注销账号的请求后至系统更新期间，我们将不再对已收集的您的个人信息做任何处理。
                            </b>
                        </p>
                        <h4>8、响应您的请求</h4>
                        <p>
                            如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品与/或服务时所产生的其他个人信息，或您认为绿色慧联存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以通过本政策载明的联系方式与我们联系。为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后15个工作日内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
                        </p>
                        <p>
                            <b>
                                在以下情形中，按照法律法规要求，我们将无法响应您的请求：
                            </b>
                        </p>
                        <p>
                            <b>（1）与国家安全、国防安全有关的；</b>
                        </p>
                        <p>
                            <b>
                                （2）与公共安全、公共卫生、重大公共利益有关的；
                            </b>
                        </p>
                        <p>
                            <b>（3）与犯罪侦查、起诉和审判等有关的；</b>
                        </p>
                        <p>
                            <b>
                                （4）有充分证据表明您存在主观恶意或滥用权利的；
                            </b>
                        </p>
                        <p>
                            <b>
                                （5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
                            </b>
                        </p>
                    </section>
                    <section>
                        <h4>六、儿童个人信息的处理</h4>
                        <p>
                            我们的产品和服务主要面向成人。尽管不同地区法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人均视为儿童。我们不允许未满14周岁的儿童注册账号或使用我们的产品和服务，并且不会有意收集任何未满周14岁儿童的信息。
                        </p>
                        <p>
                            如果任何时候监护人有理由相信我们收集了未成年人的个人信息，请通过本政策载明的联系方式联系我们，我们会采取措施尽快删除相关信息。
                        </p>
                    </section>
                    <section>
                        <h3>七、通知和修订</h3>
                        <p>
                            1、为给您提供更好的服务以及随着绿色慧联业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们将在变更或修改生效前，通过在页面显著位置提示的方式通知您，也请您访问远程慧联APP、小程序以便及时了解最新的隐私政策。
                        </p>
                        <p>
                            2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。
                        </p>
                        <p>本政策所指的重大变更包括但不限于：</p>
                        <p>
                            （1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
                        </p>
                        <p>
                            （2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
                        </p>
                        <p>
                            （3）个人信息共享、转让或公开披露的主要对象发生变化；
                        </p>
                        <p>
                            （4）您参与个人信息处理方面的权利及其行使方式发生重大变化；
                        </p>
                        <p>
                            （5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
                        </p>
                        <p>（6）个人信息安全影响评估报告表明存在高风险时。</p>
                    </section>
                    <section>
                        <h3>八、如何联系我们</h3>
                        <p>
                            如果您对本隐私政策有任何疑问、意见、投诉或建议，请通过以下方式与我们联系：
                        </p>
                        <p>热线： 400-826-2266</p>
                        <p>公司名称：浙江绿色慧联有限公司</p>
                        <p>
                            地址：浙江省杭州市滨江区西兴街道江陵路1760号1号楼1805室
                        </p>
                        <p>
                            我们将尽快审核所涉问题，并在验证您的用户身份后的15个工作日内予以回复。如果您请求删除您的敏感个人信息，我们将在10个工作日内回复处理意见或结果。
                        </p>
                        <p>
                            如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向监管部门进行投诉或举报。
                        </p>
                    </section>
                </article>
            </div>
        );
    }
}

export default PrivacyAgreement;



// WEBPACK FOOTER //
// ./src/staticPage/privacyAgreement/index.js